import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function LegalLayout({ title, description, updated, children, testid }) {
  return (
    <>
      <Seo title={title} description={description} />
      <section className="bg-[#0B1F3A] pt-[72px]">
        <div className="container-x py-14 sm:py-16">
          <p className="eyebrow eyebrow-light font-mono-alt">Legal</p>
          <h1 className="mt-3 font-display text-3xl font-bold text-white sm:text-4xl">{title.replace(" — LKTH LTD", "")}</h1>
          {updated && <p className="mt-3 font-mono-alt text-xs uppercase tracking-[0.18em] text-slate-400">Last updated: {updated}</p>}
        </div>
      </section>
      <section className="bg-[#F8FAFC] py-14 sm:py-16">
        <div className="container-x">
          <div
            data-testid={testid}
            className="card-soft mx-auto max-w-3xl p-8 sm:p-12 [&_a]:text-blue-600 [&_a]:underline [&_a]:underline-offset-2 [&_h2]:mt-10 [&_h2]:font-display [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-[#0B1F3A] [&_h2]:first:mt-0 [&_li]:mt-1.5 [&_p]:mt-3 [&_p]:text-sm [&_p]:leading-relaxed [&_p]:text-slate-600 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:text-sm [&_ul]:text-slate-600"
          >
            {children}
            <div className="mt-12 rounded-xl bg-blue-600/5 p-6 text-sm text-slate-600">
              <p className="font-semibold text-[#0B1F3A]">Questions about this policy?</p>
              <p className="mt-2">
                Email <a href="mailto:Lateshkatravath3366@gmail.com">Lateshkatravath3366@gmail.com</a> or
                write to LKTH LTD, Unit 16 Park Village, Norfolk Park Road, Sheffield, South Yorkshire,
                S2 2UA, United Kingdom.
              </p>
              <p className="mt-3">
                See also our <Link to="/privacy-policy">Privacy Policy</Link> and{" "}
                <Link to="/cookie-policy">Cookie Policy</Link>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
